export default __webpack_public_path__ + "static/media/RankIconColor.e2c71bec.svg";